import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik, FormikProvider, FieldArray } from "formik";
// import "@babel/polyfill";
import $ from "jquery";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import FindModuleById from '.././FindModuleById';

import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const EditUser = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [locationLoading, setLocationLoading] = useState([]);
  const [userRole, setUserRole] = useState([]);
  const [companyNames, setCompanyNames] = useState([]);
  const [showSelectField, setShowSelectField] = useState(false);
  // const [showCustomers, setShowCustomers] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [modulesAccess, setModulesAccess] = useState([]);
  const [permission, setPermission] = useState({});


  const formik = useFormik({
    initialValues: {
      id: value.id,
      first_name: value.first_name,
      last_name: value.last_name,
      email: value.email,
      phone_number: value.phone_number,
      user_location: value.user_location,
      user_position: value.user_position,
      profile_path: value.profile_path,
      profile_picture: value.profile_picture,
      status: value.status,
      role: value.role_id,
      company_name: value.customer_id,
      modules: permissions,
    },
    enableReinitialize: true,
   // validationSchema: EditUserSchema,
    onSubmit: (values, { setSubmitting })=> {
      axios
        .post("/users/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })

        .then((response) => {
          delete backendErrors['error'];
          setSubmitting(false);
          $("#form-submit").text("Update User");
          if (response.data.code === 200) {
            // setBackendSuccess(response.data.message);
            toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/users";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }

        }).catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
      setPermission(FindModuleById(1)); 
       console.log(permission);
    var auth_profile_image = '';
    axios
      .get(`/users/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
            var user_data =response.data.data.user;
            setPermissions(response.data.data.user.permissions)

            setValue(user_data);				
            // AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
            // AWS.config.update({
            // accessKeyValue: AWS_ACCESS_KEY_ID,
            // secretAccessKey: AWS_SECRET_ACCESS_KEY,
            // region: AWS_DEFAULT_REGION,
            // signatureVersion: 'v4',
            // });
            // const s3 = new AWS.S3();
            // var params = {Bucket: AWS_BUCKET, Key: user_data.profile_picture};
            // auth_profile_image = s3.getSignedUrl('getObject', params);
            // user_data.profile_picture = auth_profile_image;
            // console.log(auth_profile_image);
            // setValue(user_data);

      
              AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
              AWS.config.update({
                accessKeyId: AWS_ACCESS_KEY_ID,
                secretAccessKey: AWS_SECRET_ACCESS_KEY,
                region: AWS_DEFAULT_REGION,
                signatureVersion: 'v4',
              });
              const s3 = new AWS.S3();
              var params = {Bucket: AWS_BUCKET, Key: user_data.profile_picture};
              auth_profile_image = s3.getSignedUrl('getObject', params);
              user_data.profile_picture = auth_profile_image;
              setValue(user_data);

            if(user_data.role_id == 3){
              axios
              .post("/helpers/get-all-customers", {}, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                let customers = response.data.data.customers;
                  if (customers) {
                    let customerOptions = customers.map((customer, index) => ({
                      label: customer.company_name,
                      value: customer.id,
                      key: `customer-${index}`,
                    }));
        
                    setCompanyNames(customerOptions);
                    setShowSelectField(true);
                } else {
                  console.log("API response is not an array");
                }
              })
              .catch((error) => {
                console.log(error);
              });
            }
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.locations;
          let locationslist = locations.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));
          setLocationLoading(locationslist);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

         
      axios
      .get(`/helpers/all-modules`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.modules;
          let modulees = locations.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `customer-${index}`,
          }));

          setModulesAccess(modulees);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    const fetchUserRoles = async () => {
      try {
        const response = await axios.get(`/helpers/get-roles`, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        });

        if (response.data.code === 200) {
          let roles = response.data.data.roles;
          let supplier_typesList = roles.map((ord, index) => ({
            label:  ord.title ,
            value: ord.id,
            key: `supplier-${index}`,
          }));
        setUserRole(supplier_typesList);
        } else {
          console.log("API response is not an array");
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchUserRoles();
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const handleCustomerFieldChange = (event) => {
    const selectedRole = event.value;

//    setShowCustomers(false);

    //handleChange(event);

    if (selectedRole == "3") {
      axios
        .post("/helpers/get-all-customers", {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          let customers = response.data.data.customers;

          if (customers) {
            let customerOptions = customers.map((customer, index) => ({
              label: customer.company_name,
              value: customer.id,
              key: `customer-${index}`,
            }));

            setCompanyNames(customerOptions);
            setShowSelectField(true);

          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }else{
      setShowSelectField(false);
    }
  };

  const statusOptions = ([
    { value: 2, label: "Select Status" },
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ]);
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Users</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/users">Users</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">User Info</h4>
                      {permission && permission.update === 1 && (
                          <FormikProvider value={formik}>
                      
                    <form action="#" onSubmit={formik.handleSubmit}>
                      <div className="row justify-content-lg-center">
                        <div className="col-lg-10">
                          <div className="text-center py-5">
                            <label
                              className="avatar avatar-xxl profile-cover-avatar"
                              htmlFor="avatar_upload"
                            >
                              <input
                                type="file"
                                id="avatar_upload"
                                onChange={(event) => {
                                  const file = event.target.files[0];
                                  const reader = new FileReader();
                                 
                                  reader.onloadend = () => {
                                   // const profile_picture = reader.result;
                                   formik.handleChange({
                                      target: {
                                        name: "profile_picture",
                                        value: reader.result,
                                      },
                                    });
                                  };

                                  if (file) {
                                    reader.readAsDataURL(file);
                                  }
                                }}
                              />

                              <img className="avatar-img" src={ formik.values.profile_picture}   alt="Profile Image" />
                              <span className="avatar-edit">
                                <FeatherIcon
                                  icon="edit-2"
                                  className="avatar-uploader-icon shadow-soft"
                                />
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>First Name</label>
                            <input
                              type="text"
                              name="first_name"
                              value={formik.values.first_name}
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.first_name  && (
                                <span className="form-error mt-1">
                                  {backendErrors.first_name}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              type="text"
                              value={formik.values.email}
                              name="email" 
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.email && (
                                <span className="form-error mt-1">
                                  {backendErrors.email}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group status">
                            <label>Location</label>
                            {locationLoading.length > 0 && (
                              <Select
                              className="w-100"
                              value={locationLoading.find(option => option.value == formik.values.user_location) || null} // Ensure correct format
                              name="user_location"
                              onChange={(selectedOption) => {
                              handleSelectChange("user_location", selectedOption);
                              //getCustomerGNN(selectedOption.value);
                              }}
                              onBlur={formik.handleBlur}
                              options={locationLoading}
                              placeholder="Select"

                                // value={formik.values.user_location}
                                // name="user_location"
                                // data={locationLoading.map((shipp) => ({
                                //   value: shipp.id,
                                //   label: shipp.title,
                                // }))}
                                // className="w-100"
                                // onChange={(e) => {
                                //   formik.handleChange(e);
                                //   customHandleInput(e);
                                // }} onBlur={formik.handleBlur}
                                // options={{
                                //   placeholder: "Select a Location",
                                // }}
                              />
                            )}
                          
                            <small>
                              {backendErrors.user_location && (
                                  <span className="form-error mt-1">
                                    {backendErrors.user_location}
                                  </span>
                                )}
                            </small>
                          </div>
                          <div className="form-group status">
                            <label>Role</label>
                            {userRole.length > 0 && (
                              <Select
                              className="w-100"
                              value={userRole.find(option => option.value == formik.values.role) || null} // Ensure correct format
                              name="role"
                              onChange={(selectedOption) => {
                              handleSelectChange("role", selectedOption);
                              handleCustomerFieldChange(selectedOption);
                              }}
                              onBlur={formik.handleBlur}
                              options={userRole}
                              placeholder="Select"

                                // value={formik.values.role}
                                // name="role"
                                // data={userRole.map((role) => ({
                                //   value: role.id,
                                //   label: role.title,
                                // }))}
                                // className="w-100"
                                // onChange={(e) => {
                                //   formik.handleChange(e);
                                //   handleCustomerFieldChange(e);
                                //   customHandleInput(e);
                                // }}
                                // onBlur={formik.handleBlur}
                                // options={{ placeholder: "Select a User Role" }}
                              />
                            )}
                            <small>
                              {backendErrors.role && (
                                <span className="form-error mt-1">
                                  {backendErrors.role}
                                </span>
                              )}
                            </small>
                          </div>
                          {/* {(showCustomers == true) && (
                            <div className="form-group status">
                              <label>Company Name</label>
                              {companyNames.length > 0 ? (
                                <Select
                                    className="w-100"
                                    value={companyNames.find(option => option.value == formik.values.company_name) || null} // Ensure correct format
                                    name="company_name"
                                    onChange={(selectedOption) => {
                                    handleSelectChange("company_name", selectedOption);
                                    //getCustomerGNN(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={companyNames}
                                    placeholder="Select"

                                //   className= "w-100"
                                //   name="company_name"
                                //   //data={companyNames}
                                //   value={formik.values.company_name}
                                //  // name="role"
                                //   data={companyNames.map((role) => ({
                                //     value: role.id,
                                //     label: role.company_name,
                                //   }))}
                                //   onChange={(e) => {
                                //     formik.handleChange(e);
                                //     customHandleInput(e);
                                //   }}  onBlur={formik.handleBlur}
                                //   options={{
                                //     placeholder: "Select Company Name",
                                //   }}
                                />
                              ) : (
                                <p>Loading options...</p>
                              )}
                              <small>
                                {backendErrors.company_name  && (
                                    <span className="form-error mt-1">
                                      {backendErrors.company_name}
                                    </span>
                                  )}
                              </small>
                            </div>
                          )} */}
                             {showSelectField && (
                            <div className="form-group status">
                              <label>Company Name</label>
                              {companyNames.length > 0 ? (
                                <Select
                                    className="w-100"
                                    value={companyNames.find(option => option.value == formik.values.company_name) || null} // Ensure correct format
                                    name="company_name"
                                    onChange={(selectedOption) => {
                                    handleSelectChange("company_name", selectedOption);
                                    //getCustomerGNN(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={companyNames}
                                    placeholder="Select"
                                //   className="w-100"
                                //   name="company_name"
                                //   //data={companyNames}
                                //   value={formik.values.company_name}
                                //  // name="role"
                                //   data={companyNames.map((role) => ({
                                //     value: role.id,
                                //     label: role.company_name,
                                //   }))}
                                //   onChange={(e) => {
                                //     formik.handleChange(e);
                                //     customHandleInput(e);
                                //   }}  onBlur={formik.handleBlur}
                                //   options={{
                                //     placeholder: "Select Company Name",
                                //   }}
                                />
                              ) : (
                                <p>Loading options...</p>
                              )}
                              <small>
                                {backendErrors.company_name  && (
                                    <span className="form-error mt-1">
                                      {backendErrors.company_name}
                                    </span>
                                  )}
                              </small>
                            </div>
                          )}
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Last Name</label>
                            <input
                              type="text"
                              value={formik.values.last_name}
                              name="last_name"
                              className= "form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }} onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.last_name && (
                                <span className="form-error mt-1">
                                  {backendErrors.last_name}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Phone</label>
                            <input
                              type="text"
                              value={formik.values.phone_number}
                              name="phone_number"
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                                 onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.phone_number && (
                                <span className="form-error mt-1">
                                  {backendErrors.phone_number}
                                </span>
                              )}
                            </small>
                          </div>

                          <div className="form-group">
                            <label>Position</label>
                            <input
                              type="text"
                              value={formik.values.user_position}
                              name="user_position"
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.user_position && (
                                  <span className="form-error mt-1">
                                    {backendErrors.user_position}
                                  </span>
                                )}
                            </small>
                          </div>
                          <div className="form-group status">
                            <label>Status</label>
                            {statusOptions.length > 0 && (
                            <Select
                               className="w-100"
                             value={statusOptions.find(option => option.value == formik.values.status) || null} // Ensure correct format
                             name="status"
                             onChange={(selectedOption) => {
                             handleSelectChange("status", selectedOption);
                             //getCustomerGNN(selectedOption.value);
                             }}
                             onBlur={formik.handleBlur}
                             options={statusOptions}
                             placeholder="Select"
                            />
                            )}
                            <small>
                              {backendErrors.status && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}
                            </small>
                          </div>
                      

                        </div>
                      </div>

                      <FieldArray
                          name="modules"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpers.push({
                                    module_name: "",
                                    list: "",
                                    add: "",
                                    update: "",
                                    // view: "",
                                    delete: "",
                                    
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.modules.map((friend, index) => (
                                    <tr key={index}>
                                     
                                      <td>
                                        <div className="form-group status">
                                          <label>Select Module</label><br/>
                                          {modulesAccess.length > 0 && (
                                            <Select
                                            name={`modules[${index}].module_name`}
                                            options={modulesAccess}
                                            value={modulesAccess.find(option => option.value == formik.values.modules[index].module_name) || null} // Ensure correct format
                                            onChange={(selectedOption) => {
                                              formik.setFieldValue(`modules[${index}].module_name`, selectedOption.value); // ✅ Store only value in Formik
                                              customHandleInput({
                                                target: {
                                                  name: `modules[${index}].module_name`,
                                                  value: selectedOption.value, // ✅ Ensure only value is passed
                                                },
                                              });
                                            }}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select"
                                            className="w-100"
                                            // className="w-100"
                                            // name={`modules[${index}].module_name`}
                                            // data={modulesAccess}
                                            // value={
                                            //   formik.values.modules[index]
                                            //     .module_name
                                            // }
                                            
                                            // onChange={(e) => {
                                            //   formik.handleChange(e);
                                            //   customHandleInput(e);
                                            // }}
                                            //  onBlur={formik.handleBlur}
                                            // options={{
                                            //   placeholder: "Select Module",
                                            // }}
                                          />
                                          )}
                                          
                                        </div>
                                      </td>
                                      <td>
                                        <label className="custom_check w-100">
                                          <input
                                            type="checkbox"
                                            name={`modules[${index}].list`}
                                            checked={formik.values.modules[index].list === 1}
                                            onChange={(e) => {
                                              console.log(e);
                                              formik.setFieldValue(
                                                `modules[${index}].list`,
                                                formik.values.modules[index].list === 1 ? 0 : 1
                                              );
                                            }}
                                          />
                                          <span className="checkmark"></span> List
                                        </label>
                                      </td>
                                      <td>
                                        <label className="custom_check w-100">
                                          <input
                                            type="checkbox"
                                            name={`modules[${index}].add`}
                                            checked={formik.values.modules[index].add === 1}
                                            onChange={(e) => {
                                              console.log(e);
                                              formik.setFieldValue(
                                                `modules[${index}].add`,
                                                formik.values.modules[index].add === 1 ? 0 : 1
                                              );
                                            }}
                                          />
                                          <span className="checkmark"></span> Add
                                        </label>
                                      </td>
                                      <td>
                                        <label className="custom_check w-100">
                                          <input
                                            type="checkbox"
                                            name={`modules[${index}].update`}
                                            checked={formik.values.modules[index].update === 1}
                                            onChange={(e) => {
                                              console.log(e);
                                              formik.setFieldValue(
                                                `modules[${index}].update`,
                                                formik.values.modules[index].update === 1 ? 0 : 1
                                              );
                                            }}
                                          />
                                          <span className="checkmark"></span> Update
                                        </label>
                                      </td>
                                      <td>
                                        <label className="custom_check w-100">
                                          <input
                                            type="checkbox"
                                            name={`modules[${index}].delete`}
                                            checked={formik.values.modules[index].delete === 1}
                                            onChange={(e) => {
                                              console.log(e);

                                              formik.setFieldValue(
                                                `modules[${index}].delete`,
                                                formik.values.modules[index].delete === 1 ? 0 : 1
                                              );
                                            }}
                                          />
                                          <span className="checkmark"></span> Delete
                                        </label>
                                      </td>
                                        { formik.values.modules[index].module_name == 251 &&(
                                    <td>
                                          <label className="custom_check w-100">
                                            <input type="checkbox" 
                                            name={`modules[${index}].other_1`}
                                            checked={formik.values.modules[index].other_1 === 1}
                                            onChange={(e) => {
                                              console.log(e);

                                              formik.setFieldValue(
                                                `modules[${index}].other_1`,
                                                formik.values.modules[index].other_1 === 1 ? 0 : 1
                                              );
                                            }}
                                           
                                            onBlur={formik.handleBlur}
                                            />
                                            <span className="checkmark"></span> Fixed 
                                        </label>
                                      </td>
                                     )}
                                     
                                     
                                      { formik.values.modules[index].module_name == 251 &&(
                                        <td>
                                          <label className="custom_check w-100">
                                            <input type="checkbox" 
                                            name={`modules[${index}].other_2`}
                                            checked={formik.values.modules[index].other_2 === 1}
                                            onChange={(e) => {
                                              console.log(e);

                                              formik.setFieldValue(
                                                `modules[${index}].other_2`,
                                                formik.values.modules[index].other_2 === 1 ? 0 : 1
                                              );
                                            }}
                                            onBlur={formik.handleBlur}
                                            />
                                            <span className="checkmark"></span> Saisonal
                                        </label>
                                      </td>
                                      )}
                                     
                                     
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />     
                 

                      <small>
                        
                          {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}
                      </small>

                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={formik.isSubmitting}
                        >
                          Update User
                        </button>
                      </div>
                    </form>
                
                
                    </FormikProvider>
)}
                  
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditUser;
